import { render } from "./OrderRelatedPage.vue?vue&type=template&id=204b704c&scoped=true"
import script from "./OrderRelatedPage.vue?vue&type=script&lang=js"
export * from "./OrderRelatedPage.vue?vue&type=script&lang=js"

import "./OrderRelatedPage.vue?vue&type=style&index=0&id=204b704c&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-204b704c"]])

export default __exports__